import { Action } from 'redux';
import { ClassifierTypeModel } from '../../../api/admin/admin.types';
import { Page } from '../../../api/api.types';

export const GET_CLASSIFIER_TYPES_LIST = 'GET_CLASSIFIER_TYPES_LIST';

export interface ClassifierTypeState {
  classifierTypes: ClassifierTypeModel[];
}

export interface GetClassifierTypesListAction extends Action {
  type: typeof GET_CLASSIFIER_TYPES_LIST;
  payload: {
    page: Page<ClassifierTypeModel>;
  };
}

export type ClassifierTypeActionTypes = GetClassifierTypesListAction;
